export const getModeClass = ({ error, touched, active, submitting, disabled, readOnly }) => {
    if (submitting || disabled || readOnly) {
        return 'disabled';
    }

    if (active) {
        return 'focus';
    }

    if (!touched) {
        return '';
    }

    return error ? 'invalid' : 'valid';
};
